import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FilterOption } from './_models/filterOption';

@Component({
    selector: 'app-header', templateUrl: './header.component.html', styleUrls: ['./header.component.scss'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderComponent {
    @Input() brandIconName: string = '';
    @Input() subtitle: string = '';
    @Input() title: string = '';
    @Input() shouldCopyTitleInfo: boolean = false;
    @Output() onCopyTitleInfo?: EventEmitter<any> = new EventEmitter<any>();

    @Input() isLoading: boolean = false;
    @Input() searchInput: string | number = '';
    @Input() searchMask: string = '';
    @Input() searchPlaceholder: string = '';
    @Input() searchType: 'text' | 'number' = 'text';
    @Input() hasMinCharacters: boolean = true;
    @Input() hasSearchButton: boolean = true;
    @Output() onSearch?: EventEmitter<any> = new EventEmitter<any>();

    @Input() hasBackButton: boolean = true;
    @Input() hasButtons: boolean = true;
    @Output() onGoBack?: EventEmitter<null> = new EventEmitter<null>();

    @Input() filterInput?: string | number = ''
    @Input() filterLabel?: string = ''
    @Input() filterOptions?: FilterOption[] = [];
    @Output() onFilter?: EventEmitter<any> = new EventEmitter<any>();

    copyTitleInfo() {
        this.onCopyTitleInfo.emit(null)
    }

    filterControl(value) {
        this.onFilter.emit(value)
    }

    goBack() {
        this.onGoBack.emit(null)
    }

    searchControl(value) {
        this.onSearch.emit(value);
    }

    get filter() {
        return this.filterInput;
    }

    set filter(value) {
        this.filterInput = value;
        this.filterControl(value);
    }

    get search() {
        return this.searchInput;
    }

    set search(value) {
        this.searchInput = value;

        if(this.hasSearchButton && value.toString().length != 0)
            return

        this.searchControl(value);
    }
}
